import { useTranslation } from "react-i18next";
import useMainFilter from "../../hooks/useMainFilter";
import useMobile from "../../hooks/useMobile";
import React, { ReactElement, ReactNode, useMemo } from "react";
import CurrentAccountCard from "../../components/CurrentAccountCard/CurrentAccountCard";
import CollapsibleBlock from "../../components/CollapsibleBlock/CollapsibleBlock";
import { ETransactionType } from "../../helpers/constants";
import useCurrentAccount from "../../hooks/useCurrentAccount";
import { formatCurrency, getTotalByTransactionType } from "../../helpers/utils";
import useCollapsibles from "../../hooks/useCollapsibles";

interface IReportsSidebar {
  page?: "reports" | "transactions" | "recycle";
  children?: ReactElement;
  append?: ReactNode;
  prepend?: ReactNode;
}

const ReportsSidebar: React.FC<IReportsSidebar> = ({
  children = null,
  append = <></>,
  prepend = <></>,
}) => {
  const { mainFilter } = useMainFilter();
  const { collapsiblePreferences, updateCollapsible } = useCollapsibles();
  const { isMobile } = useMobile();
  const { t } = useTranslation();
  const { activeTransactions, currencySymbol } = useCurrentAccount();

  const getAvailableMoney = useMemo(() => {
    const income = getTotalByTransactionType({
      type: ETransactionType.INCOME,
      transactions: activeTransactions,
    });
    const expenses = getTotalByTransactionType({
      type: ETransactionType.EXPENSE,
      transactions: activeTransactions,
    });

    return income - expenses;
  }, [activeTransactions]);

  if (!mainFilter?.account) {
    return null;
  }

  return (
    <>
      {!isMobile && (
        <>
          {prepend}
          <CollapsibleBlock
            title={t("Cuenta")}
            uppercase
            badge={formatCurrency({
              value: getAvailableMoney,
              currency: currencySymbol,
            })}
            open={collapsiblePreferences.accountOpen}
            onChange={(isOpen: boolean) =>
              updateCollapsible({ accountOpen: isOpen })
            }
          >
            <CurrentAccountCard />
          </CollapsibleBlock>

          {append}

          {/* <ReceivedInvitesList />
          <ReceivedTransactionsList />
          <TransactionsPendingList
            type={ETransactionType.EXPENSE}
            onlyCurrentAccount
          />
          <TransactionsPendingList
            type={ETransactionType.INCOME}
            onlyCurrentAccount
          /> */}
        </>
      )}
    </>
  );
};

export default React.memo(ReportsSidebar);
